import { render } from "./testpal-ai-chatbox.vue?vue&type=template&id=c039be32&scoped=true"
import script from "./testpal-ai-chatbox.vue?vue&type=script&lang=js"
export * from "./testpal-ai-chatbox.vue?vue&type=script&lang=js"

import "./testpal-ai-chatbox.vue?vue&type=style&index=0&id=c039be32&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c039be32"]])

export default __exports__